module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if (nodes) {

    ; __append("<ul class=\"group-items\">")
    ; 

_.forEach(nodes, function(node) {
    var  styleCSS = '';
    if (typeof node.iconColor !== 'undefined') {
        styleCSS = 'color: ' + node.iconColor;
    }

    ; __append("\r\n<li role=\"button\" class=\"has-menu\">\r\n    <i  data-toggle=\"collapse\" data-target=\"#well")
    ; __append(escapeFn(node.id))
    ; __append("\" data-itemid=\"")
    ; __append(escapeFn(node.id))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(node.groupType))
    ; __append("\" data-nodeType=\"")
    ; __append(escapeFn(node.nodeType))
    ; __append("\" class=\"switch collapsed ")
    ; __append(escapeFn(node.toggleIcon))
    ; __append("\"></i>\r\n    <span class=\"icon ")
    ; __append(escapeFn(node.icon))
    ; __append("\" style=\"")
    ; __append(escapeFn(styleCSS))
    ; __append("\"></span>\r\n    <a class=\"item-link\" data-target=\"#well")
    ; __append(escapeFn(node.id))
    ; __append("\" data-itemid=\"")
    ; __append(escapeFn(node.id))
    ; __append("\" data-linkid=\"")
    ; __append(escapeFn(node.linkId))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(node.groupType))
    ; __append("\" data-nodeType=\"")
    ; __append(escapeFn(node.nodeType))
    ; __append("\" role=\"\" data-parentId=\"")
    ; __append(escapeFn(node.parentId))
    ; __append("\" title=\"")
    ; __append(escapeFn(node.nodeName))
    ; __append("\">\r\n        ")
    ; __append(escapeFn(node.nodeName))
    ; __append("\r\n    </a>\r\n</li>\r\n")
    ; 
if (node.hasChildren) {

    ; __append("\r\n<div id=\"well")
    ; __append(escapeFn(node.id))
    ; __append("\" class=\"bo-body collapse\">\r\n    <ul class=\"group-items\">\r\n        ")
    ; 
        _.forEach(node.nodes, function(subNode) {
        
    ; __append("\r\n        <li role=\"button\"  >\r\n            <i  data-toggle=\"collapse\" data-target=\"#well")
    ; __append(escapeFn(subNode.id))
    ; __append("\" data-itemid=\"")
    ; __append(escapeFn(subNode.id))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(subNode.groupType))
    ; __append("\" data-nodeType=\"")
    ; __append(escapeFn(subNode.nodeType))
    ; __append("\" class=\"switch collapsed ")
    ; __append(escapeFn(subNode.toggleIcon))
    ; __append("\"></i>\r\n            <span class=\"icon ")
    ; __append(escapeFn(subNode.icon))
    ; __append("\"></span>\r\n            <a class=\"item-link\" data-itemid=\"")
    ; __append(escapeFn(subNode.id))
    ; __append("\"  data-linkid=\"")
    ; __append(escapeFn(subNode.linkId))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(subNode.groupType))
    ; __append("\" data-nodeType=\"")
    ; __append(escapeFn(subNode.nodeType))
    ; __append("\" role=\"\" data-parentId=\"")
    ; __append(escapeFn(subNode.parentId))
    ; __append("\" title=\"")
    ; __append(escapeFn(node.nodeName))
    ; __append("\">\r\n                ")
    ; __append(escapeFn(subNode.nodeName))
    ; __append("\r\n            </a>\r\n        </li>\r\n\r\n        ")
    ; 
        if (subNode.hasChildren) {
        
    ; __append("\r\n            <div id=\"well")
    ; __append(escapeFn(subNode.id))
    ; __append("\" class=\"bo-body collapse\">\r\n                <ul class=\"group-items\"></ul>\r\n            </div>\r\n\r\n        ")
    ; 
        }
        });
        
    ; __append("\r\n\r\n    </ul>\r\n</div>\r\n")
    ; 
}
});


    ; __append("\r\n</ul>\r\n")
    ; 
};

  }
  return __output;

}